var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.ProductSideSwitcher},_vm._l((_vm.$store.getters['product/images']),function({ key: side, src }){return _c('div',{key:side,class:[
      _vm.$style.SideSwitcher,
      {
        [_vm.$style['SideSwitcher--active']]:
          side === _vm.$store.state.activePrintSide
      }
    ],on:{"click":function($event){return _vm.setCurrentSide(side)}}},[_c('img',{staticClass:"hidden md:block md:float-none",attrs:{"src":src,"alt":_vm.translate(side)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }